import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopExternalIdResponse } from '@/repositories/generated';

const response: ShopExternalIdResponse[] = [
  {
    externalId: 'shop001',
  },
  {
    externalId: 'shop002',
  },
  {
    externalId: 'shop003',
  },
];

export const autocompleteExternalShopId = http.get(
  createMockEndpoint('/autocomplete/shop/externalId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
